// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-stop-progress-bar {
  position: relative;
  display: flex;
  align-items: center;
}

  .app-stop-progress-bar__stop-btn {
    width: 24px;
    height: 23px;
    min-width: 24px;
    min-height: 23px;
    padding: 3px;
  }

  .app-stop-progress-bar__stop-btn svg {
      width: 100% !important;
      height: 100% !important;
    }

  .app-stop-progress-bar__stop-btn--selected {
      border-color: var(--btn-color-primary-0);
    }

  .app-stop-progress-bar__head {
    display: flex;
    align-items: center;
    height: 21px;
  }

  .app-stop-progress-bar__head > * {
      margin-right: 6px;
    }

  .app-stop-progress-bar__head-icon {
      height: 21px;
    }

  .app-stop-progress-bar__head-icon--actionable:hover {
          color: var(--btn-color-primary-0);
          cursor: pointer;
        }

  .app-stop-progress-bar__head-icon--selected {
        color: var(--btn-color-primary-0);
      }

  .app-stop-progress-bar__head-icon--error {
        fill: red;
      }

  .app-stop-progress-bar__progress-line {
    display: flex;
    border: 0;
    flex-grow: 1;
    height: 3px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .app-stop-progress-bar__progress-line--first {
      border-radius: 8px 0 0 8px;
    }

  .app-stop-progress-bar__progress-line--last {
      width: 18px;
      border-radius: 0 8px 8px 0;
    }

  /* Colors */

  .app-stop-progress-bar__progress-line--ready {
      background-color: #dbdbdb;
    }

  .app-stop-progress-bar__progress-line--next {
      background-color: #00b0ff;
    }

  .app-stop-progress-bar__progress-line--in-progress {
      background-color: #00b0ff;
      animation-name: stop-in-progress;
      animation-duration: 2000ms;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }

  .app-stop-progress-bar__progress-line--complete {
      background-color: #02c853;
    }

  .app-stop-progress-bar__progress-line--error {
      background-color: #ff1544;
    }

  .app-stop-progress-bar__progress-line-codes {
      height: 25px;
    }

  .app-stop-progress-bar__progress-line-codes--ready {
        color: #dbdbdb;
      }

  .app-stop-progress-bar__progress-line-codes--next {
        color: #00b0ff;
      }

  .app-stop-progress-bar__progress-line-codes--in-progress {
        color: #00b0ff;
      }

  .app-stop-progress-bar__progress-line-codes--complete {
        color: #02c853;
      }

  .app-stop-progress-bar__progress-line-codes--error {
        color: #ff1544;
      }

@keyframes stop-in-progress {
  from {
    transform: rotate3d(1, 0, 0, 0deg);
  }

  to {
    transform: rotate3d(1, 0, 0, 360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./app/pages/DispatchPage/components/StopProgressBar/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AAiHrB;;EA/GE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;EAUd;;EARE;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;EAEA;MACE,wCAAwC;IAC1C;;EAGF;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EAwBd;;EAtBE;MACE,iBAAiB;IACnB;;EAEA;MACE,YAAY;IAgBd;;EAbI;UACE,iCAAiC;UACjC,eAAe;QACjB;;EAGF;QACE,iCAAiC;MACnC;;EAEA;QACE,SAAS;MACX;;EAIJ;IACE,aAAa;IACb,SAAS;IACT,YAAY;IACZ,WAAW;IACX,qDAAqD;EA2DvD;;EAzDE;MACE,0BAA0B;IAC5B;;EAEA;MACE,WAAW;MACX,0BAA0B;IAC5B;;EAEA,WAAW;;EACX;MACE,yBAAyB;IAC3B;;EAEA;MACE,yBAAyB;IAC3B;;EAEA;MACE,yBAAyB;MACzB,gCAAgC;MAChC,0BAA0B;MAC1B,mCAAmC;MACnC,iCAAiC;IACnC;;EAEA;MACE,yBAAyB;IAC3B;;EAEA;MACE,yBAAyB;IAC3B;;EAEA;MACE,YAAY;IAqBd;;EAnBE;QACE,cAAc;MAChB;;EAEA;QACE,cAAc;MAChB;;EAEA;QACE,cAAc;MAChB;;EAEA;QACE,cAAc;MAChB;;EAEA;QACE,cAAc;MAChB;;AAKN;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,oCAAoC;EACtC;AACF","sourcesContent":[".app-stop-progress-bar {\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  &__stop-btn {\n    width: 24px;\n    height: 23px;\n    min-width: 24px;\n    min-height: 23px;\n    padding: 3px;\n\n    & svg {\n      width: 100% !important;\n      height: 100% !important;\n    }\n\n    &--selected {\n      border-color: var(--btn-color-primary-0);\n    }\n  }\n\n  &__head {\n    display: flex;\n    align-items: center;\n    height: 21px;\n\n    & > * {\n      margin-right: 6px;\n    }\n\n    &-icon {\n      height: 21px;\n\n      &--actionable {\n        &:hover {\n          color: var(--btn-color-primary-0);\n          cursor: pointer;\n        }\n      }\n\n      &--selected {\n        color: var(--btn-color-primary-0);\n      }\n\n      &--error {\n        fill: red;\n      }\n    }\n  }\n\n  &__progress-line {\n    display: flex;\n    border: 0;\n    flex-grow: 1;\n    height: 3px;\n    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n\n    &--first {\n      border-radius: 8px 0 0 8px;\n    }\n\n    &--last {\n      width: 18px;\n      border-radius: 0 8px 8px 0;\n    }\n\n    /* Colors */\n    &--ready {\n      background-color: #dbdbdb;\n    }\n\n    &--next {\n      background-color: #00b0ff;\n    }\n\n    &--in-progress {\n      background-color: #00b0ff;\n      animation-name: stop-in-progress;\n      animation-duration: 2000ms;\n      animation-iteration-count: infinite;\n      animation-timing-function: linear;\n    }\n\n    &--complete {\n      background-color: #02c853;\n    }\n\n    &--error {\n      background-color: #ff1544;\n    }\n\n    &-codes {\n      height: 25px;\n\n      &--ready {\n        color: #dbdbdb;\n      }\n\n      &--next {\n        color: #00b0ff;\n      }\n\n      &--in-progress {\n        color: #00b0ff;\n      }\n\n      &--complete {\n        color: #02c853;\n      }\n\n      &--error {\n        color: #ff1544;\n      }\n    }\n  }\n}\n\n@keyframes stop-in-progress {\n  from {\n    transform: rotate3d(1, 0, 0, 0deg);\n  }\n\n  to {\n    transform: rotate3d(1, 0, 0, 360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
